import { CouponDealTypeEnum } from "@saleor/types/globalTypes";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  Sort,
  TabActionDialog
} from "../types";

const couponsSectionUrl = "/coupons/";

export enum CouponsListUrlFiltersEnum {
  query = "query",
  couponFeatured = "isFeatured",
  startDate = "startDate",
  endDate = "endDate",
  dealType = "dealType"
}

export enum CouponRedemptionListUrlFiltersEnum {
  query = "query",
  claimedDate = "claimedDate",
  redeemedDate = "redeemedDate",
  status = "status",
  date = "date"
}

export enum CouponsRankingListUrlFiltersEnum {
  query = "query",
  dealType = "dealType"
}

export enum CouponsRedemptionListUrlFilterWithMultipleValues {
  status = "status"
}

export enum CouponsListUrlFilterWithMultipleValues {
  status = "status",
  mall = "mall"
}
export enum CouponRedemptionListUrlSortField {
  name = "name",
  code = "code",
  claimedAt = "claimedAt",
  redeemedAt = "redeemedAt"
}

export enum CouponCollectionListUrlFiltersEnum {
  query = "query"
}

export type CouponsListUrlFilters = Filters<CouponsListUrlFiltersEnum> &
  FiltersWithMultipleValues<CouponsListUrlFilterWithMultipleValues> & {
    dealType?: CouponDealTypeEnum[];
  };
export type CouponsRankingListUrlFilters = Filters<
  CouponsRankingListUrlFiltersEnum
> &
  FiltersWithMultipleValues<CouponsListUrlFilterWithMultipleValues> & {
    dealType?: CouponDealTypeEnum[];
  };
export type CouponListUrlDialog = TabActionDialog;
export type CouponsListUrlQueryParams = ActiveTab &
  BulkAction &
  CouponsListUrlFilters &
  Dialog<CouponListUrlDialog> &
  Pagination;
export type CouponsUrlQueryParams = Pagination;

export type CouponsRankingListUrlQueryParams = ActiveTab &
  BulkAction &
  CouponsRankingListUrlFilters;

export type CouponCollectionListUrlFilters = Filters<
  CouponCollectionListUrlFiltersEnum
>;

export const couponManageUrl = urlJoin(couponsSectionUrl, "manage");

export const couponListPath = couponManageUrl;

export const couponRedemptionSection = urlJoin(
  couponManageUrl,
  "coupon-redemption"
);

export const couponRankingSection = urlJoin(
  couponsSectionUrl,
  "coupon-ranking"
);

export const couponRedemptionListPath = couponRedemptionSection;

export const couponRankingListPath = couponRankingSection;

export const couponListUrl = (params?: CouponsListUrlQueryParams): string =>
  couponManageUrl + "?" + stringifyQs(params);

export const couponPath = (id: string) => urlJoin(couponManageUrl, id);

export const couponUrl = (id: string, params?: CouponsUrlQueryParams) =>
  couponPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const couponSetCodesUrl = (id: string) =>
  urlJoin(couponPath(encodeURIComponent(id)), "set-codes");

export const couponAddUnlockCodesUrl = (id: string) =>
  urlJoin(couponSetCodesUrl(id), "add-unlock-codes");

export const couponRedemptionListUrl = (
  id?: string,
  params?: CouponsRedemptionListUrlQueryParams
) => couponRedemptionPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const couponRankingListUrl = (
  params?: CouponsRankingListUrlQueryParams
): string => couponRankingSection + "?" + stringifyQs(params);

export const couponAddPath = urlJoin(couponManageUrl, "add-coupons");

export const couponAddUrl = () => couponAddPath;

export type CouponRedemptionListUrlFilters = Filters<
  CouponRedemptionListUrlFiltersEnum
> &
  FiltersWithMultipleValues<CouponsRedemptionListUrlFilterWithMultipleValues>;
export type CouponRedemptionListSort = Sort<CouponRedemptionListUrlSortField>;
export type CouponsRedemptionListUrlQueryParams = ActiveTab &
  CouponRedemptionListSort &
  Pagination &
  CouponRedemptionListUrlFilters;
export type CouponRedemptionUrlQueryParams = Pagination;
export const couponRedemptionPath = (id: string) =>
  urlJoin(couponRedemptionSection, id);

export const couponCollectionsSectionUrl = urlJoin(
  couponsSectionUrl,
  "collection"
);
export type CouponCollectionListUrlQueryParams = ActiveTab &
  Pagination &
  CouponCollectionListUrlFilters;

export const couponCollectionListUrl = (
  params?: CouponsListUrlQueryParams
): string => couponCollectionsSectionUrl + "?" + stringifyQs(params);

export const couponCollectionsPath = couponCollectionsSectionUrl;
export const couponCollectionsUrl = (params?: string): string =>
  couponCollectionsPath + "?" + stringifyQs(params);

export const couponCollectionAddPath = urlJoin(
  couponCollectionsSectionUrl,
  "add-collection"
);
export const couponCollectionAddUrl = () => couponCollectionAddPath;

export type CouponCollectionDetailsUrlDialog = "unassign" | "deactivate";
export type CouponCollectionDetailsQueryParams = BulkAction &
  Pagination &
  Dialog<CouponCollectionDetailsUrlDialog>;

export const couponCollectionViewPath = (id: string) =>
  urlJoin(couponCollectionsSectionUrl, "view-collection", id);

export const couponCollectionViewUrl = (
  id: string,
  params?: CouponCollectionDetailsQueryParams
) =>
  couponCollectionViewPath(encodeURIComponent(id) + "?" + stringifyQs(params));

export const couponEditUnlockCodeUrl = (
  couponId: string,
  unlockCodeId: string
) =>
  urlJoin(
    couponSetCodesUrl(couponId),
    "edit-unlock-codes",
    encodeURIComponent(unlockCodeId)
  );
